import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import {
    Card,
    CardBody,
} from "reactstrap"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { useLocation } from "react-router-dom"
import breadcrumbs from "common/Breadcrumbs"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import DeleteModel from "common/deleteModel/deleteModel"
import { exportDataExcel } from "components/Common/ExportData"
import { dateFormat } from "pages/Common"
import ErrorModel from "common/errorModel/errorModel"
import EmployeeAdvanceLogTable from "./EmployeeAdvanceLogTable"
import EmployeeAdvanceModal from "./EmployeeAdvanceModal"

function EmployeeAdvanceLog() {
    document.title = `Employee Advance Log | Raja Rani Couture`
    let { pathname } = useLocation()
    const { deleteApi, getApi, postApi, putApi } = useApi()
    const navigate = useNavigate()

    // useStates
    const [isEdit, setIsEdit] = useState(false)
    const [editData, setEditData] = useState(null)
    const [tableData, setTableData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [screenLoad, setScreenLoad] = useState(false)
    const [searchText, setSearchText] = useState("")
    const [isMobile, setisMobile] = useState(window.innerWidth < 768)
    const [displayStart, setDisplayStart] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(20)
    const [userFilter, setUserFilter] = useState(0)
    const [users, setUsers] = useState([])
    const [dateFilter, setDateFilter] = useState([new Date(), new Date()])
    const [dateDisble, setdateDisble] = useState(true)
    const [totalRecords, setTotalRecords] = useState(0)
    const [statusFilter, setStatusFilter] = useState(0)
    const [TaskTitleTypes, setTaskTitleTypes] = useState(
        (JSON.parse(localStorage?.getItem("authUser")).TaskTitleTypes)
    )
    const [empAdvanceLogModal, setEmployeeLeaveModal] = useState(false);


    const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
        setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
        setSearchText(serchValue == undefined ? "" : serchValue)
        setRowsPerPage(pageSize)
    }

    useEffect(() => {
        getApi('Attendance/user-lookup').then(({ data, status }) => {
            if (status === 200) {
                setUsers(data)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }, [])

    // user list api
    const EmpAdvanceListApi = () => {
        setIsLoading(true)
        setScreenLoad(true)
        postApi("Attendance/emp-Advance-log-list", {
            fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                dateFilter[0],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                dateFilter[1],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            AttendanceUserId: (JSON.parse(localStorage.getItem("authUser")).RoleName == "Admin" || JSON.parse(localStorage.getItem("authUser")).RoleName == "Master") ? parseInt(userFilter) : JSON.parse(localStorage?.getItem("authUser")).AttendanceUserId,
            displayStart: displayStart,
            pageSize: rowsPerPage,
            searchText: searchText.trim(),
            sortColumn: "",
            sortOrder: "asc",
        }).then(({ data, status }) => {
            if (status === 200) {
                setTableData(data?.EmpAdvanceLogList)
                setTotalRecords(data?.TotalRecords)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
            setIsLoading(false)
            setScreenLoad(false)
        })
    }

    // user list api useEffect
    useEffect(() => {
        if (dateFilter[1] != undefined) {
            EmpAdvanceListApi()
        }
    }, [searchText, displayStart, rowsPerPage, userFilter, dateFilter, dateDisble])

    // Delete user handler
    const handleDelete = Id => {
        setScreenLoad(true)
        if (Id) {
            DeleteModel.confirmDeleteInquiry({
                title: "Are you sure? ",
                text: "You want to delete this advance permanently? ",
                isMobile,
            }).then(response => {
                if (response == true) {
                    deleteApi(`Attendance/emp-advance-delete?id=${Id}`).then(
                        async ({ data, status }) => {
                            if (status === 200) {
                                const updatedArray = tableData
                                    .map(obj => (obj.Id !== Id ? obj : null))
                                    .filter(Boolean)
                                setTableData(updatedArray)
                                toast.success("Sucessfully deleted", {
                                    style: {
                                        fontSize: "15px",
                                    },
                                })
                            } else {
                                ErrorModel.errormodel({
                                    title: "Verify Attendence",
                                    text: data,
                                })
                            }
                            setScreenLoad(false)
                        }
                    )
                } else {
                    setScreenLoad(false)
                }
            })
        }
    }

    // Update user handler
    const handleEditCustomer = (customerData) => {
        if (customerData) {
            setEditData(customerData)
            setIsEdit(true)
            empAdvanceLogToggle()
        }
    }

    const empAdvanceLogToggle = () => {
        setEmployeeLeaveModal(!empAdvanceLogModal)
    }

    // Create user handler
    const handleCreateUpdateEmpAdvanceLog = () => {
        setIsEdit(false)
        setEditData('')
        empAdvanceLogToggle()
    }

    // table headers & accessor
    const columns = useMemo(
        () => [
            {
                Header: "Name",
                accessor: "Name",
            },
            // {
            //     Header: "Is Pay To Emp",
            //     Header: () => (
            //         <div
            //             style={{
            //                 textAlign: "center",
            //             }}
            //         >
            //             Pay to Employee
            //         </div>
            //     ),
            //     accessor: "IsPayToEmp",
            //     width: "8%",
            //     Cell: ({ row }) => {
            //         return (
            //             <div style={{
            //                 display: "flex",
            //                 alignItems: "center",
            //                 justifyContent: "center",
            //                 textAlign: "center"
            //             }}>
            //                 {row?.original?.IsPayToEmp ? 'YES' : "NO"}
            //             </div>
            //         )
            //     },
            // },
            {
                Header: "Pay Advance",
                Header: () => (
                    <div
                        style={{
                            textAlign: "right",
                        }}
                    >
                        Pay Advance
                    </div>
                ),
                accessor: "PayAdvance",
                width: "8%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}>
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row?.original?.IsPayToEmp ? row?.original?.Advance || 0 : 0.00)}
                        </div>
                    )
                },
            },
            {
                Header: "Return Advance",
                Header: () => (
                    <div
                        style={{
                            textAlign: "right",
                        }}
                    >
                        Return Advance
                    </div>
                ),
                accessor: "ReturnAdvance",
                width: "8%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}>
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row?.original?.IsPayToEmp ? 0.00 : row?.original?.Advance || 0)}
                        </div>
                    )
                },
            },
            {
                Header: "Remarks",
                accessor: "Remarks",
                // width: "15%",
                Cell: ({ row }) => {
                    return (
                        <div>
                            {row.original.Remarks ? row.original.Remarks : "N/A"}
                        </div>
                    )
                },
            },
            {
                Header: "Created On",
                accessor: "CreatedOn",
                width: "9%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original?.CreatedOn == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(row.original?.CreatedOn?.split("T")[0], "dd-MM-yyyy")}
                    </p>
                ),
            },
            {
                Header: "Action",
                width: "6%",
                accessor: "action",
                disableFilters: true,
                Cell: ({ row }) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
                            {row.original.EmployeeSalaryLogId > 0 ?
                                <>
                                    <li className="mytooltip">
                                        <i
                                            className={`fs-6 fas fa-edit`}
                                            style={{ cursor: "not-allowed", color: "#808080b3" }}
                                        ></i>
                                        <span className="mytext">Edit</span>
                                    </li>
                                    <li className="mytooltip">
                                        <i
                                            className={`fs-6 fas fa-trash-alt btn-delete`}
                                            style={{ cursor: "not-allowed", color: "#808080b3" }}
                                        ></i>
                                        <span className="mytext">Delete</span>
                                    </li>
                                </>
                                :
                                <>
                                    {((TaskTitleTypes == null)) &&
                                        <li className="mytooltip">
                                            <i
                                                className=" fs-6 fas fa-edit btn-edit"
                                                id={`edittooltip${row.original.Id}`}
                                                onClick={() => handleEditCustomer(row.original)}
                                            ></i>
                                            <span className="mytext">Edit</span>
                                        </li>
                                    }

                                    {(TaskTitleTypes == null) &&
                                        <li className="mytooltip">
                                            <i
                                                className="fs-6 fas fa-trash-alt btn-delete"
                                                id={`deletetooltip${row.original.Id}`}
                                                onClick={() => handleDelete(row.original.Id)}
                                            ></i>
                                            <span className="mytext">Delete</span>
                                        </li>
                                    }
                                </>
                            }
                        </ul>
                    )
                },
            },
        ],
        [tableData]
    )

    function writeDataToExcel() {
        if (!dateDisble) {
            toast.error("Please Select date", {
                icon: "⚠️",
                style: {
                    fontSize: "15px",
                },
            })
        } else {
            setIsLoading(true)
            let header = ["Name", "Pay Advance", "Return Advance", "Remarks", "Created On"];
            const mainTitle = "Employye Advance";
            const widthObj = [{
                Key: "A",
                Value: 10,
            },
            {
                Key: "B",
                Value: 19,
            },
            {
                Key: "C",
                Value: 19,
            },
            {
                Key: "D",
                Value: 19,
            },
            {
                Key: "E",
                Value: 19,
            },
            {
                Key: "F",
                Value: 19,
            },
            {
                Key: "G",
                Value: 19,
            },
            {
                Key: "H",
                Value: 19,
            },
            {
                Key: "I",
                Value: 19,
            },
            {
                Key: "J",
                Value: 19,
            },
            ]
            const extention = "Employee_Advance.xlsx"
            let excelSheetData = []

            postApi("Attendance/emp-Advance-log-list", {
                fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                    dateFilter[0],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
                toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                    dateFilter[1],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
                AttendanceUserId: (JSON.parse(localStorage.getItem("authUser")).RoleName == "Admin" || JSON.parse(localStorage.getItem("authUser")).RoleName == "Master") ? parseInt(userFilter) : JSON.parse(localStorage?.getItem("authUser")).AttendanceUserId,
                displayStart: displayStart,
                pageSize: 10000,
                searchText: searchText.trim(),
                sortColumn: "",
                sortOrder: "asc",
            }).then(({ data, status }) => {
                if (status === 200) {
                    for (let index = 0; index < data?.EmpAdvanceLogList.length; index++) {
                        let dataObj = {
                            Name: data?.EmpAdvanceLogList[index].Name,
                            payAdvance: Math.round(data?.EmpAdvanceLogList[index].IsPayToEmp ? data?.EmpAdvanceLogList[index].Advance : 0).toFixed(2),
                            returnAdvance: Math.round(data?.EmpAdvanceLogList[index].IsPayToEmp ? 0 : data?.EmpAdvanceLogList[index].Advance).toFixed(2),
                            Remarks: data?.EmpAdvanceLogList[index].Remarks ? data?.EmpAdvanceLogList[index].Remarks : "N/A",
                            CreatedOn: data?.EmpAdvanceLogList[index].CreatedOn == null
                                ? "N/A"
                                : dateFormat(data?.EmpAdvanceLogList[index].CreatedOn, "dd-MM-yyyy"),
                        }
                        excelSheetData.push(dataObj)
                    }
                    var fields = Object.keys(excelSheetData[0]);
                    var sheetData = excelSheetData.map(function (row) {
                        return fields.map(function (fieldName) {
                            return row[fieldName];
                        });
                    });
                    setIsLoading(false)
                    sheetData.unshift(header);
                    exportDataExcel(sheetData, mainTitle, widthObj, extention)
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
                setIsLoading(false)
                setScreenLoad(false)
            })

            setIsLoading(false)
        }
    }

    return (
        <div className="page-content">
            <div className="container-fluid">
                {screenLoad && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].parent}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                    link={breadcrumbs[pathname].parentLink}
                />
                <Card>
                    <CardBody>
                        <EmployeeAdvanceLogTable
                            columns={columns}
                            data={tableData}
                            isGlobalFilter={true}
                            isAddUserList={true}
                            handleCreateUpdateEmpAdvanceLog={handleCreateUpdateEmpAdvanceLog}
                            customPageSize={10}
                            className="custom-header-css"
                            isLoading={isLoading}
                            TotalRecords={totalRecords}
                            pagePerSize={pagePerSize}
                            setDateFilter={setDateFilter}
                            dateFilter={dateFilter}
                            users={users}
                            userFilter={userFilter}
                            setUserFilter={setUserFilter}
                            setdateDisble={setdateDisble}
                            dateDisble={dateDisble}
                            writeDataToExcel={writeDataToExcel}
                            statusFilter={statusFilter}
                            setStatusFilter={setStatusFilter}
                        />
                        {empAdvanceLogModal &&
                            <EmployeeAdvanceModal
                                modal={empAdvanceLogModal}
                                toggle={empAdvanceLogToggle}
                                isEdit={isEdit}
                                editData={editData}
                                EmpAdvanceListApi={EmpAdvanceListApi}
                            />
                        }
                    </CardBody>
                </Card>
            </div>
        </div>
    )
}
EmployeeAdvanceLog.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
    onFilterChange: PropTypes.func,
}

export default EmployeeAdvanceLog
